import { render, staticRenderFns } from "./badges_stack.vue?vue&type=template&id=4498c3d5&scoped=true"
import script from "./badges_stack.vue?vue&type=script&lang=js"
export * from "./badges_stack.vue?vue&type=script&lang=js"
import style0 from "./badges_stack.vue?vue&type=style&index=0&id=4498c3d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498c3d5",
  null
  
)

export default component.exports